import { useCallback } from 'react';
import { useRootStackNavigation } from '../../../../hooks/useRootNavigation';

/**
 * 기가입 채널 안내 화면으로 이동 (현재 화면 대체).
 * 안내에 쓸 channel/email(PII)은 URL 노출을 피해 아톰으로 따로 전달하고,
 * 여기서는 재로그인 복귀에 필요한 redirect(비밀 아님)만 URL(?redirect=)로 유지한다.
 * 재로그인 시 startXxxLogin이 window.location.search에서 redirect를 다시 읽는다.
 */
export const useMoveToAlreadyRegistered = () => {
  const navigation = useRootStackNavigation();

  return useCallback(
    (redirect?: string) => {
      navigation.replace('AlreadyRegistered', redirect ? { redirect } : {});
    },
    [navigation],
  );
};
